(function () {
  'use strict';

  var STORAGE_KEY = 'collection_scroll_state';
  var INFINITE_CONTAINER = '.collection__infinite-container';
  var INFINITE_TRIGGER = '.collection__infinite-trigger';
  var PRODUCT_ITEM = '.product-item';
  var COLLECTION_SECTION = '[data-section-type="collection"]';
  var SAFETY_PAGE_LIMIT = 10;

  function getConfig() {
    return (window.theme && window.theme.felina) || {};
  }

  function isEnabled() {
    return getConfig().enableCollectionScrollMemory !== false;
  }

  function dispatchThemeEvent(eventName) {
    document.dispatchEvent(new CustomEvent(eventName));
  }

  function notifyProductsAdded() {
    document.dispatchEvent(new CustomEvent('felina:collection-products-added'));

    if (window.FelinaProductCardSwatches && typeof window.FelinaProductCardSwatches.refresh === 'function') {
      window.FelinaProductCardSwatches.refresh();
    }

    if (window.FelinaProductCardLayout && typeof window.FelinaProductCardLayout.refreshMatchHeight === 'function') {
      window.FelinaProductCardLayout.refreshMatchHeight();
    }

    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    }

    if (typeof window.FlairApp !== 'undefined' && typeof window.FlairApp.refreshProductBadges === 'function') {
      window.FlairApp.refreshProductBadges();
    }
  }

  function CollectionScrollMemory() {
    this.isRestoring = false;
    this.isProductNavigation = false;
    this.isBreadcrumbNavigation = false;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    this.init();
  }

  CollectionScrollMemory.prototype.init = function () {
    var self = this;

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        self.clearState();
      }
    });

    if (this.shouldRestore()) {
      this.isRestoring = true;
      window.__collectionScrollRestoring = true;
      window.scrollTo({ top: 0, behavior: 'instant' });
      this.showPreloader();

      requestAnimationFrame(function () {
        setTimeout(function () {
          self.restorePosition();
        }, 200);
      });
    }

    this.trackProductClicks();
    this.trackBreadcrumbClicks();

    window.addEventListener('pagehide', function () {
      if (!self.isProductNavigation && !self.isBreadcrumbNavigation) {
        self.clearState();
      }
    });
  };

  CollectionScrollMemory.prototype.getCollectionSection = function () {
    return document.querySelector(COLLECTION_SECTION);
  };

  CollectionScrollMemory.prototype.getProductsPerPage = function () {
    var section = this.getCollectionSection();
    var perPage = parseInt(section && section.dataset.collectionItemsPerPage, 10);
    return perPage > 0 ? perPage : 32;
  };

  CollectionScrollMemory.prototype.trackProductClicks = function () {
    var self = this;

    document.addEventListener('click', function (event) {
      var productLink = event.target.closest('a[href*="/products/"]');
      if (!productLink || !productLink.closest(COLLECTION_SECTION)) return;

      self.isProductNavigation = true;
      self.saveState({
        scrollY: window.scrollY,
        productHandle: self.extractHandle(productLink.href),
        page: self.getCurrentPage(),
        loadedProductCount: document.querySelectorAll(PRODUCT_ITEM).length,
        timestamp: Date.now(),
        url: window.location.href,
        fromCollection: true,
        navigationType: 'product'
      });
    });
  };

  CollectionScrollMemory.prototype.trackBreadcrumbClicks = function () {
    var self = this;

    document.addEventListener('click', function (event) {
      var breadcrumbLink = event.target.closest('a.breadcrumbs__link[href*="/collections/"]');
      if (!breadcrumbLink) return;

      var breadcrumbUrl = new URL(breadcrumbLink.href, window.location.origin);
      var currentUrl = new URL(window.location.href);

      if (breadcrumbUrl.pathname !== currentUrl.pathname) return;

      self.isBreadcrumbNavigation = true;
      self.saveState({
        scrollY: window.scrollY,
        productHandle: null,
        page: self.getCurrentPage(),
        loadedProductCount: document.querySelectorAll(PRODUCT_ITEM).length,
        timestamp: Date.now(),
        url: window.location.href,
        fromCollection: true,
        navigationType: 'breadcrumb'
      });
    });
  };

  CollectionScrollMemory.prototype.saveState = function (data) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

  CollectionScrollMemory.prototype.getState = function () {
    var data = sessionStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  };

  CollectionScrollMemory.prototype.clearState = function () {
    sessionStorage.removeItem(STORAGE_KEY);
  };

  CollectionScrollMemory.prototype.shouldRestore = function () {
    var state = this.getState();
    if (!state) return false;

    var isRecent = Date.now() - state.timestamp < 300000;
    var fromProduct = document.referrer.includes('/products/');
    var fromCollection = document.referrer.includes('/collections/');
    var navigationEntry = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType('navigation')[0]
      : null;
    var isBackNavigation =
      (window.performance && window.performance.navigation && window.performance.navigation.type === 2) ||
      (navigationEntry && navigationEntry.type === 'back_forward');

    return (
      isRecent &&
      state.url === window.location.href &&
      state.fromCollection &&
      (fromProduct || fromCollection || isBackNavigation)
    );
  };

  CollectionScrollMemory.prototype.findTargetProduct = function (productHandle) {
    if (!productHandle) return null;
    return document.querySelector('[data-identify-product-handle="' + productHandle + '"]');
  };

  CollectionScrollMemory.prototype.hasNextPage = function () {
    var ajaxinateButton = document.querySelector(INFINITE_TRIGGER + ' a[href]');
    return !!ajaxinateButton;
  };

  CollectionScrollMemory.prototype.restorePosition = function () {
    var self = this;
    var state = this.getState();

    if (!state) {
      this.finishRestoring();
      return;
    }

    if (state.navigationType === 'breadcrumb') {
      this.restoreScrollOnly(state).then(function () {
        self.finishRestoring();
      });
      return;
    }

    var targetProduct = this.findTargetProduct(state.productHandle);

    if (targetProduct) {
      requestAnimationFrame(function () {
        self.scrollToProduct(targetProduct);
        self.finishRestoring();
      });
      return;
    }

    if (!this.hasNextPage()) {
      window.scrollTo({ top: state.scrollY, behavior: 'instant' });
      this.finishRestoring();
      return;
    }

    this.loadUntilVisible(state).then(function () {
      self.finishRestoring();
    });
  };

  CollectionScrollMemory.prototype.finishRestoring = function () {
    this.isRestoring = false;
    window.__collectionScrollRestoring = false;
    window.dispatchEvent(new CustomEvent('collectionScrollRestored'));
    this.hidePreloader();
    this.clearState();
    notifyProductsAdded();
  };

  CollectionScrollMemory.prototype.fetchNextPage = function () {
    var ajaxinateButton = document.querySelector(INFINITE_TRIGGER + ' a[href]');
    if (!ajaxinateButton) return Promise.resolve(false);

    var nextPageUrl = ajaxinateButton.href;
    if (!nextPageUrl) return Promise.resolve(false);

    return fetch(nextPageUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch collection page');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContainers = doc.querySelectorAll(INFINITE_CONTAINER);
        var newPaginations = doc.querySelectorAll(INFINITE_TRIGGER);
        var newContainer = newContainers[0];
        var newPagination = newPaginations[0];

        if (!newContainer) return false;

        var currentContainer = document.querySelector(INFINITE_CONTAINER);
        if (currentContainer && newContainer.innerHTML.trim()) {
          currentContainer.insertAdjacentHTML('beforeend', newContainer.innerHTML);
        }

        var paginationContainer = document.querySelector(INFINITE_TRIGGER);
        if (paginationContainer && newPagination) {
          paginationContainer.innerHTML = newPagination.innerHTML;
        } else if (paginationContainer) {
          paginationContainer.innerHTML = '';
          return true;
        } else {
          return false;
        }

        notifyProductsAdded();
        dispatchThemeEvent('collection:updated');
        return true;
      })
      .catch(function () {
        return false;
      });
  };

  CollectionScrollMemory.prototype.wait = function (ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  };

  CollectionScrollMemory.prototype.restoreScrollOnly = function (state) {
    var self = this;
    var targetCount = state.loadedProductCount || 0;
    var attempts = 0;

    function step() {
      var currentCount = document.querySelectorAll(PRODUCT_ITEM).length;

      if (currentCount >= targetCount || !self.hasNextPage() || attempts >= SAFETY_PAGE_LIMIT) {
        window.scrollTo({ top: state.scrollY, behavior: 'instant' });
        return Promise.resolve();
      }

      return self.fetchNextPage().then(function (loaded) {
        if (!loaded) {
          window.scrollTo({ top: state.scrollY, behavior: 'instant' });
          return Promise.resolve();
        }

        attempts += 1;
        return self.wait(200).then(step);
      });
    }

    return step();
  };

  CollectionScrollMemory.prototype.loadUntilVisible = function (state) {
    var self = this;
    var attempts = 0;

    function step() {
      var targetProduct = self.findTargetProduct(state.productHandle);

      if (targetProduct) {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            self.scrollToProduct(targetProduct);
            resolve();
          });
        });
      }

      if (!self.hasNextPage() || attempts >= SAFETY_PAGE_LIMIT) {
        window.scrollTo({ top: state.scrollY, behavior: 'instant' });
        return Promise.resolve();
      }

      var productCountBefore = document.querySelectorAll(PRODUCT_ITEM).length;

      return self.fetchNextPage().then(function (loaded) {
        if (!loaded) {
          window.scrollTo({ top: state.scrollY, behavior: 'instant' });
          return Promise.resolve();
        }

        return self.wait(300).then(function () {
          var productCountAfter = document.querySelectorAll(PRODUCT_ITEM).length;

          if (productCountAfter === productCountBefore) {
            window.scrollTo({ top: state.scrollY, behavior: 'instant' });
            return Promise.resolve();
          }

          attempts += 1;
          return step();
        });
      });
    }

    return step();
  };

  CollectionScrollMemory.prototype.scrollToProduct = function (element) {
    var headerOffset = 100;
    var offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'instant'
    });

    element.style.transition = 'outline 0.3s ease';
    element.style.outline = '3px solid rgba(0, 123, 255, 0.5)';
    setTimeout(function () {
      element.style.outline = '';
    }, 2000);
  };

  CollectionScrollMemory.prototype.getCurrentPage = function () {
    var perPage = this.getProductsPerPage();
    var totalProducts = document.querySelectorAll(PRODUCT_ITEM).length;
    return Math.max(1, Math.ceil(totalProducts / perPage));
  };

  CollectionScrollMemory.prototype.extractHandle = function (url) {
    var match = url.match(/\/products\/([^?/#]+)/);
    return match ? match[1] : null;
  };

  CollectionScrollMemory.prototype.showPreloader = function () {
    if (document.getElementById('scroll-restore-preloader')) return;

    var preloader = document.createElement('div');
    preloader.id = 'scroll-restore-preloader';
    preloader.className = 'collection-scroll-restore';
    preloader.innerHTML =
      '<div class="collection-scroll-restore__overlay" aria-hidden="true"></div>' +
      '<div class="collection-scroll-restore__content" role="status" aria-live="polite">' +
      '<div class="loader">' +
      '<div class="loader__wrap">' +
      '<div class="loader__bar"></div>' +
      '</div>' +
      '</div>' +
      '<p class="collection-scroll-restore__message">Picking up where you left off...</p>' +
      '</div>';

    document.body.appendChild(preloader);
  };

  CollectionScrollMemory.prototype.hidePreloader = function () {
    var preloader = document.getElementById('scroll-restore-preloader');
    if (!preloader) return;

    preloader.classList.add('collection-scroll-restore--hidden');
    setTimeout(function () {
      preloader.remove();
    }, 300);
  };

  if (!isEnabled()) return;

  if (document.body.classList.contains('template-collection')) {
    window.collectionScrollMemory = new CollectionScrollMemory();
  }
})();
